import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { MutationConfig } from 'src/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import axios from 'src/lib/axios';
import { Voucher } from 'src/features/vouchers/utils/types';
import { VoucherFormSchemaValues } from 'src/features/vouchers/utils/formSchema';

const RESOURCE = '/discounts/voucher/';

type MutationFnType = typeof mutationFn;

const mutationFn = ({ ...data }: VoucherFormSchemaValues): Promise<Voucher> => {
    return axios.post(formatResourcePath(RESOURCE), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateVoucher };
